import React from "react";
import Modal from "../../Modal";

const EditTopicDetail = ({ setUpdateState }) => {
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a
            className="CloseModal"
            onClick={() => {
              setUpdateState((prev) => ({
                ...prev,
                editTopicModal: false,
              }));
            }}
          >
            ×
          </a>
          <h3>Edit Topic Details</h3>
          <div className="form-group">
            <label>Lecture Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Course Name (Auto-fill)"
            />
          </div>
          <div className="CommonForm">
            <div className="form-group mb-0">
              <label>Upload Lecture</label>
            </div>
            <div className="UploadBox Image">
              <span>
                <img src="images/upload.png" />
              </span>
              <p>
                <label>Upload Lecture Video</label> <br /> or drag &amp; drop
              </p>
            </div>
            <div className="UploadBox">
              <span>
                <img src="images/upload-video.png" />
              </span>
              <p>
                <label>Upload Lecture Video</label> <br /> or drag &amp; drop
              </p>
            </div>
          </div>
          <button className="Button" data-dismiss="modal">
            Update
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditTopicDetail;
